// extracted by mini-css-extract-plugin
module.exports = {"colorParcelle":"#ec6525","colorParcelleSelected":"#093"};